module.exports = __webpack_public_path__ + "static/media/Green_Coffee_Peeling_retina.d58cf07d.jpg";